import Vue from 'vue'
import Router from 'vue-router'
import store from './../store/store'

import RoomSelectView from '@/components/RoomSelectView'
import BookingEditView from '@/components/BookingEditView'
import BookingCreateView from '@/components/BookingCreateView'
import LoginView from '@/components/LoginView'
import RegisterView from '@/components/RegisterView'
import VerifyRegisterationView from '@/components/VerifyRegisterationView'
import RoomListView from '@/components/RoomListView'
import RoomCreateView from '@/components/RoomCreateView'
import RoomEditView from '@/components/RoomEditView'
import SingleRoomTimetableView from '@/components/SingleRoomTimetableView'
import UserInfoView from '@/components/UserInfoView'
import ChangePasswordView from '@/components/ChangePasswordView'
import ForgotPasswordView from '@/components/ForgotPasswordView'
import ChangeForgottenPasswordView from '@/components/ChangeForgottenPasswordView'
import CodeGenerateView from '@/components/CodeGenerateView'

import { isAdmin } from './../utils/cognito'

Vue.use(Router)

const auth = {
  sessionFound: store.getters['Auth/sessionFound'],
  sessionValid: store.getters['Auth/sessionValid'],
  refresh: () => { store.dispatch('Auth/authRefresh') }
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/date/:date/bookings/:id',
      name: 'BookingEditView',
      component: BookingEditView
    },
    {
      path: '/reserve/room/:room/date/:date',
      name: 'BookingCreateView',
      component: BookingCreateView
    },
    {
      path: '/rooms',
      name: 'RoomListView',
      component: RoomListView
    },
    {
      path: '/rooms/create',
      name: 'RoomCreateView',
      component: RoomCreateView
    },
    {
      path: '/rooms/:id',
      name: 'RoomEditView',
      component: RoomEditView
    },
    {
      path: '/login',
      name: 'LoginView',
      component: LoginView,
      meta: {
        public: true,
      }
    },
    {
      path: '/register',
      name: 'RegisterView',
      component: RegisterView,
      meta: {
        public: true,
      }
    },
    {
      path: '/verify',
      name: 'VerifyRegisterationView',
      component: VerifyRegisterationView,
      meta: {
        public: true,
      }
    },
    {
      path: '/rooms/:roomId/date/:date',
      name: 'SingleRoomTimetableView',
      component: SingleRoomTimetableView
    },
    {
      path: '/user',
      name: 'UserInfoView',
      component: UserInfoView
    },
    {
      path: '/user/change-password',
      name: 'ChangePasswordView',
      component: ChangePasswordView
    },
    {
      path: '/forgotpassword',
      name: 'ForgotPasswordView',
      component: ForgotPasswordView,
      meta: {
        public: true,
      }
    },
    {
      path: '/forgotpassword/change',
      name: 'ChangeForgottenPasswordView',
      component: ChangeForgottenPasswordView,
      meta: {
        public: true,
      }
    },
    {
      path: '/admin/generate-codes',
      name: 'CodeGenerateView',
      component: CodeGenerateView,
      meta: {
        admin: true,
      }
    },
    {
      path: '/',
      name: 'RoomSelectView',
      component: RoomSelectView
    },
    {
      path: '*',
      redirect: '/'
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.public !== true)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    console.log('beforeEach "' + to.fullPath + '" requires auth');

    if (auth.sessionFound()) {
      if (to.matched.some(record => record.meta.admin === true)) {
        console.log('requires admin');
        if (!isAdmin()) {
          return next(false)
        }
      }

      if (auth.sessionValid()) {
        console.log('session valid');

        return next()
      } else {
        console.log('refreshing');
        auth.refresh();
        return next()
      }
    } else {
      console.log('not logged in');
      return next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
    // next()
  } else {
    console.log('beforeEach "' + to.fullPath + '" is public');
    return next()
  }
})

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.public !== true)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     console.log('beforeEach "' + to.fullPath + '" requires auth');

//     if (auth.sessionFound()) {
//       if (auth.sessionValid()) {
//         next()
//       } else {
//         auth.refresh();
//         next()
//       }
//     } else {
//       console.log('not logged in');
//       next({
//         path: '/login',
//         query: { redirect: to.fullPath }
//       })
//     }
//     // next()
//   } else {
//     console.log('beforeEach "' + to.fullPath + '" is public');
//     next()
//   }
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js